import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

import './TaxonomyLookupModalFooter.scss';

function TaxonomyLookupModalFooter({ close, opModel, applyChanges, transferEnabled }) {
  return (
    <div className="taxonomyLookupModal__footer">
      <div className="taxonomyLookupModal__footer_buttons">
        <Button
          data-e2e="taxonomyLookupModal-footer-cancel"
          type="secondary"
          size="small"
          aria-label="Cancel"
          onClick={close}
          className="e2e-taxonomyLookupModal-footer-cancel">
          Cancel
        </Button>
        <Button
          data-e2e="taxonomyLookupModal-footer-transfer"
          type="primary"
          size="small"
          disabled={opModel.selection.length === 0 && !transferEnabled}
          aria-disabled={opModel.selection.length === 0 && !transferEnabled}
          aria-label="Transfer"
          onClick={applyChanges}
          className="e2e-taxonomyLookupModal-footer-transfer">
          Transfer
        </Button>
      </div>
    </div>
  );
}

TaxonomyLookupModalFooter.propTypes = {
  opModel: PropTypes.object,
  transferEnabled: PropTypes.bool,
  close: PropTypes.func.isRequired,
  applyChanges: PropTypes.func.isRequired,
};

export default TaxonomyLookupModalFooter;
